<template>
  <div class="pa-front-page pa-front-page-index">
    <FrontPageCurtainLogo />

    <StoryCardSwiper :isVisible="isVisibleStoryCard" />

    <PaCheckedSeparator />

    <PaFrontActionButtons />

    <PaIndexMainField />

    <PaIndexFooter />

    <LoginModal />

    <!-- <PAFrontRegistrationTest /> -->
  </div>
</template>

<script>
import FrontPageCurtainLogo from '@/components/FrontParts/FrontPageCurtainLogo/FrontPageCurtainLogo.vue'

import StoryCardSwiper      from '@/components/FrontParts/StoryCardSwiper/StoryCardSwiper.vue'
import PaCheckedSeparator   from '@/components/FrontParts/PaCheckedSeparator/PaCheckedSeparator.vue'
import PaFrontActionButtons from '@/components/FrontParts/PaFrontActionButtons/PaFrontActionButtons.vue'

import PaIndexMainField     from '@/components/FrontParts/PaIndexMainField/PaIndexMainField.vue'

import PaIndexFooter        from '@/components/FrontParts/PaIndexFooter/PaIndexFooter.vue'

import LoginModal           from '@/components/FrontParts/LoginModal/LoginModal.vue'

// import PAFrontRegistrationTest from '@/components/FrontParts/PAFrontRegistrationTest/PAFrontRegistrationTest.vue'

import FrontPageMixins      from '@/mixins/FrontPageMixins'

export default {
  mixins : [
    FrontPageMixins
  ],
  
  components : {
    FrontPageCurtainLogo,
    StoryCardSwiper,
    PaCheckedSeparator,
    PaFrontActionButtons,
    PaIndexMainField,
    PaIndexFooter,
    LoginModal,
    // PAFrontRegistrationTest
  },

  data(){
    return {
      isVisibleStoryCard  : false
    };
  },
  
  async mounted(){
    this.$on('mountedPage', () => {
      this.$nextTick(() => {
        this.isVisibleStoryCard = true;
      });
    });

    await this.initializePage();
  }
}
</script>

<style lang="scss">
.pa-front-page{
  &-index{
    
  }
}
</style>